<template>
  <div class="pa-3">
    <v-row>
      <v-col cols="12" sm="6" lg="8" class="pa-1 pb-0">
        <v-btn v-if="!hidecreateupload && (hidecreate !== undefined ? !hidecreate : true)" color="primary" @click="folderDialog" :disabled="documentLoading" class="mb-2">{{ $t('message.hse.createNew') }}</v-btn><!--  || !modelObj.sharepoint_id -->
        <v-btn v-if="!hidecreateupload" color="primary" @click="documentDialog" :disabled="documentLoading" class="mb-2 ml-3">{{ $t('message.hse.upload') }}</v-btn>
      </v-col>
      <v-col cols="12" sm="6" lg="4" class="pa-1 pb-0">
        <v-text-field dense outlined clearable append-icon="search" @keyup.enter="sharepointSearch"
          persistent-hint :hint="$t('message.common.searchTriggerHint')"
          @click:append="sharepointSearch" single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right" id="searchbtn"></v-text-field>
      </v-col>
    </v-row>
    <!-- <v-btn color="primary" @click="templateHandler" :disabled="documentLoading" class="mb-2 ml-3">{{ $t('message.common.create') }}</v-btn> -->
    <v-progress-linear class="mt-3" indeterminate v-if="loading || documentLoading" color="primary darken-2"></v-progress-linear>
    <template v-if="showSearchView">
      <div v-if="searchResults.length > 0">
        <v-simple-table dense class="elevation-1 bordered--table document" style="width: 100%;overflow: hidden">
          <template v-slot:default>
            <thead>
              <tr>
                <th>{{ $t('message.customer.name') }}</th>
                <th>{{ $t('message.common.modifiedOn') }}</th>
                <th>{{ $t('message.common.action') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(document) in searchResults" :key="document.weburl">
                <td>
                  <v-btn size="32" text icon>
                    <v-icon :size="32" :color="$formatter.mimeTypeOfDocument(document.mimetype).color">{{ $formatter.mimeTypeOfDocument(document.mimetype).icon }}</v-icon>
                  </v-btn>
                  {{ document.title }}
                </td>
                <td>{{ document.lastmodifiedtime | dateFormat }}</td>
                <td>
                  <a href="javascript:void(0)" @click="openDocument(document.isdocument ? document.path : document.weburl)">
                    <v-icon>launch</v-icon>
                  </a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <template v-else>
        <v-alert prominent text type="info" class="mt-2">
          <v-row align="center">
            <v-col class="grow">{{ $t('message.common.noResults') }}</v-col>
          </v-row>
        </v-alert>
      </template>
    </template>
    <template v-else>
      <v-breadcrumbs class="pa-1" :items="parentBreadCrumbItems">
        <template v-slot:item="{ item }">
          <a href="javascript:void(0)" @click="navigateToItem(item)">
            {{ item.text ? item.text.toUpperCase(): '' }}
          </a>
        </template>
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
      <div @drop="drop" @dragover="onDragover" @dragleave="onDragLeave" >
        <div id="spDoc">
          <template v-if="listOfParentDocuments && listOfParentDocuments.length > 0 || documentLoading">
          <documents
            :listOfDocuments="listOfParentDocuments"
            :listOfProperties="listOfProperties"
            :dateFieldsForConversion="dateFieldsForConversion"
            :folderActions="folderActions"
            :documentActions="documentActions"
            :isChild="false"
            :subModule="{ module: {}, index: 0 }"
            :loadChildrenItems="getSubFoldersItems">
          </documents>
        </template>
        <template v-else>
          <v-alert prominent text type="info" class="mt-2">
            <v-row align="center">
              <v-col class="grow">{{ $t('message.common.noResults') }}</v-col>
            </v-row>
          </v-alert>
        </template>
        </div>
      </div>
    </template>
    <v-dialog v-model="uploadDocumentDialog" width="600" persistent>
      <form-template :references.sync="propertiesFormReference" :model="propertyModel.properties" ref="documentReference"></form-template>
    </v-dialog>
    <v-dialog v-model="createFolderDialog" width="400" persistent>
      <form-template :references.sync="createFolderReferences" :model="folderObj" ref="folderReference"></form-template>
    </v-dialog>
    <v-dialog v-model="templateDialog" width="600" persistent>
      <form-template :references.sync="templateFormReference" :model="propertyModel.properties" ref="documentReference"></form-template>
    </v-dialog>
    <!--Version Dialog-->
    <v-dialog v-model="versionHistoryDialog" width="1000" persistent>
      <v-card>
        <versions :versionHistory="versionHistory"></versions>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="error" @click="versionHistoryDialog = false">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import { mapState } from 'vuex'
import documentHelper from '@/components/Documents/document_upload'
export default {
  props: ['modelObj', 'module', 'hidecreateupload', 'orderOrOffer', 'hidecreate'],
  data () {
    return {
      listOfAddress: [],
      templateList: [],
      dynamicFormFields: [],
      dateFieldsForConversion: [],
      propertyModel: {},
      folderObj: {},
      folderLoading: false,
      formProps: [],
      listOfProperties: [],
      listOfParentDocuments: [],
      listOfRelatedDocuments: [],
      isShowAttachment: false,
      documentFormloading: false,
      uploadDocumentDialog: false,
      createFolderDialog: false,
      templateDialog: false,
      loading: false,
      MODULE_URL: 'sharepoint',
      versionHistoryDialog: false,
      versionHistory: [],
      documentLoading: false,
      sharepoint_id: '',
      documentsPanel: [1],
      parentBreadCrumbItems: [],
      isCreateFolder: false,
      listOfBatchNumbers: [],
      droppedFiles: null,
      search: '',
      searchResults: [],
      showSearchView: false
    }
  },
  mixins: [documentHelper],
  computed: {
    ...mapState(['FORM_TYPE', 'userDetails'])
  },
  components: {
    'form-template': () => import('@/components/FormTemplate'),
    documents: () => import('@/components/Documents/Document'),
    Versions: () => import('@/components/Documents/Versions')
  },
  mounted () {
    this.sharepoint_id = this.$route.query.id
    this.getAllDocumentsAndProperties()
    if (this.module === this.SP_PRODUCT) this.getProductBatchNumbers()
    // this.getModuleTemplates()
    this.$eventBus.$on('deleteSuccess', (data) => {
      let moduleUrl = this.MODULE_URL
      if (this.orderOrOffer) moduleUrl += this.orderOrOffer
      if (data === moduleUrl) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteSuccess') })
        this.$store.commit('hideDialog')
        this.getAllDocumentsAndProperties()
      }
    })
  },
  watch: {
    'search' (val) {
      if (!val) {
        this.listOfParentDocuments = []
        this.getAllDocumentsAndProperties()
      }
    }
  },
  methods: {
    drop (event) {
      event.preventDefault()
      event.currentTarget.classList.remove('areaBg')
      if (document.querySelector('.theme--light.v-data-table')) document.querySelector('.theme--light.v-data-table').style.backgroundColor = '#FFFFFF'
      this.documentDialog(event.dataTransfer.files)
    },
    onDragover (event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains('areaBg')) {
        event.currentTarget.classList.add('areaBg')
        if (document.querySelector('.theme--light.v-data-table') && document.querySelector('.theme--light.v-data-table').style.backgroundColor !== 'lightgray') {
          document.querySelector('.theme--light.v-data-table').style.backgroundColor = 'lightgray'
          document.querySelector('.theme--light.v-data-table').style.opacity = 0.8
        }
      }
    },
    onDragLeave (event) {
      event.preventDefault()
      if (document.querySelector('.theme--light.v-data-table')) document.querySelector('.theme--light.v-data-table').style.backgroundColor = '#FFFFFF'
      event.currentTarget.classList.remove('areaBg')
    },
    getProductBatchNumbers () {
      this.$_executeApi('get', `warehouseorderitems/get_batchnumbers_by_product?product_id=${this.modelObj.id}`)
        .then(response => {
          this.listOfBatchNumbers = []
          if (response) {
            this.listOfBatchNumbers = response.data
          }
        })
    },
    sharepointSearch () {
      if (this.search) {
        this.showSearchView = true
        this.searchResults = []
        this.documentLoading = true
        const path = this.modelObj.sharepoint_id
        const model = { term: this.search, path, onlydocument: false }
        this.$_executeApi('post', 'sharepoint/search', model).then(response => {
          const list = response.data
          list.forEach(element => {
            if (!element.isdocument) element.mimetype = 'folder'
          })
          this.searchResults = list
        })
          .finally(() => {
            this.documentLoading = false
          })
      }
    },
    openDocument (path) {
      window.open(path, '_blank')
    },
    getAllDocumentsAndProperties () {
      this.documentLoading = true
      this.showSearchView = false
      let module = ''
      let recordId = ''
      // let getParentComp = null
      recordId = this.modelObj.id
      switch (this.module) {
        case this.SP_CUSTOMER: module = 'get_customer_documents_and_fields'
          break
        case this.SP_PRODUCTION_ORDER: module = 'get_order_documents_and_fields'
          break
        case this.SP_PRODUCT: module = 'get_product_documents_and_fields'
          break
        case this.SP_SUPPLIER_ORDER: module = 'get_supplierorder_documents_and_fields'
          break
        case this.SP_SALE_ORDER: module = 'get_saleorder_documents_and_fields'
          break
      }
      this.$_executeApi('get', `${this.MODULE_URL}/${module}/${recordId}`)
        .then((response) => {
          // getParentComp = this.$parent.$parent.customer
          // if (this.$route.params.customer_id) {
          //   getParentComp = this.$parent.$parent.customer
          // } else getParentComp = this.$parent.$parent.order
          // const { sharepoint_id, customer_name, name, number } = getParentComp
          this.parentBreadCrumbItems = [{ id: this.modelObj.sharepoint_id, text: `${this.modelObj.number || ''} ${(this.modelObj.name) || ''}` }]
          const avaliableProps = response.data.fields || []
          this.dynamicFormFields = this.$formatter.cloneVariable(avaliableProps)
          avaliableProps.unshift({ title: 'Type' })
          this.listOfProperties = avaliableProps
          const getAllDocumentsObj = response.data.sharepointmultifolderitems
          const parentList = getAllDocumentsObj && getAllDocumentsObj.parentfolderitems ? getAllDocumentsObj.parentfolderitems : []
          parentList.forEach(element => {
            if (!element.is_document) {
              element.mimetype = 'folder'
              element.isRoot = true
            }
          })
          this.listOfParentDocuments = parentList
          const childrenList = getAllDocumentsObj && getAllDocumentsObj.childrenfolderitems ? getAllDocumentsObj.childrenfolderitems : []
          childrenList.forEach(element => {
            element.breadcrumps = [{ id: element.folder_id, text: '', icon: 'mdi-home' }]
            element.items.forEach(child => {
              if (!child.is_document) child.mimetype = 'folder'
            })
          })
          this.listOfRelatedDocuments = childrenList
          this.prepareFieldsForProperties()
        })
        .finally(() => {
          this.documentLoading = false
        })
    },
    getSubFoldersItems (item) {
      if (item.id) {
        this.documentLoading = true
        this.$_executeApi('get', `sharepoint/get_subfolder_items/${item.id}`)
          .then((response) => {
            const list = response.data
            list.forEach(element => {
              if (!element.is_document) element.mimetype = 'folder'
            })
            this.listOfParentDocuments = list
            const breadcrumbItem = { id: item.id, text: item.name, path: item.path, isRoot: item.isRoot }
            const getIndex = this.parentBreadCrumbItems.findIndex(x => x.id === item.id)
            if (getIndex >= 0) {
              const getAll = getIndex + 1
              const getTotalCount = this.parentBreadCrumbItems.length
              this.parentBreadCrumbItems.splice(getAll, getTotalCount - getAll)
            } else {
              this.parentBreadCrumbItems.push(breadcrumbItem)
            }
          })
          .finally(() => {
            this.documentLoading = false
          })
      } else {
        switch (this.module) {
          case this.SP_PRODUCT: this.$root.$emit('get_product_details')
            break
          case this.SP_SUPPLIER_ORDER: this.$root.$emit('get_supplierorder_details')
            break
          case this.SP_PRODUCTION_ORDER: this.$root.$emit('get_orderfromoffer_details')
            break
          case this.SP_SALE_ORDER: this.$root.$emit('get_salesorder_details')
            break
        }
      }
    },
    async uploadDocumentHandler () {
      if (this.$refs.documentReference.$refs.validateForm.validate()) {
        this.documentFormloading = true
        const props = this.propertyModel.properties
        const transformData = { date: { list: this.dateFieldsForConversion, from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
        const model = this.$formatter.formatModel(props, transformData)
        const formData = new FormData()
        // let module = ''
        const recordId = this.modelObj.id
        // get active route folder and upload under there
        const getAllLength = this.parentBreadCrumbItems.length
        const getSharepointId = this.parentBreadCrumbItems[getAllLength - 1] ? this.parentBreadCrumbItems[getAllLength - 1].id : this.modelObj.sharepoint_id
        // return false
        formData.append('parent_id', getSharepointId)
        formData.append('module', this.module)
        formData.append('batch_number', this.propertyModel.properties && this.propertyModel.properties.batchNo ? this.propertyModel.properties.batchNo : '')
        formData.append('record_id', recordId)
        let url = 'upload'
        if (this.propertyModel.isVersion) {
          formData.append('document_id', this.propertyModel.document_id)
          url = 'upload_version'
        }
        const files = props.files
        files.forEach(file => {
          formData.append(file.name, file)
        })
        const modelObj = await this.generateModelFromFields(model, this.propertiesFormReference)
        formData.append('properties', modelObj)
        this.$_executeApi('post', `${this.MODULE_URL}/${url}`, formData)
          .then((response) => {
            if (response) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.uploadedSuccess') })
              this.closeDocumentDialogHandler()
              const getItem = { id: getSharepointId }
              this.getSubFoldersItems(getItem)
              if (!getSharepointId) {
                switch (this.module) {
                  case this.SP_PRODUCT: this.$root.$emit('get_product_details')
                }
              }
            }
          })
          .finally(() => {
            this.documentFormloading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    async updateDocumentMeta () {
      if (this.$refs.documentReference.$refs.validateForm.validate()) {
        this.documentFormloading = true
        let model = this.$formatter.cloneVariable(this.propertyModel.properties)
        // get active route folder and upload under there
        const getAllLength = this.parentBreadCrumbItems.length
        const getSharepointId = this.parentBreadCrumbItems[getAllLength - 1] ? this.parentBreadCrumbItems[getAllLength - 1].id : this.modelObj.sharepoint_id

        this.propertyModel.parent_id = getSharepointId
        const transformData = { date: { list: this.dateFieldsForConversion, from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
        model = this.$formatter.formatModel(model, transformData)
        const resultObj = {}
        const modelObj = await this.generateModelFromFields(model, this.propertiesFormReference)
        resultObj.properties = modelObj
        resultObj.parent_id = getSharepointId
        this.$_executeApi('put', `${this.MODULE_URL}/update_doc_meta_data/${this.propertyModel.id}`, resultObj)
          .then(() => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
          })
          .finally(() => {
            this.documentFormloading = false
            this.closeDocumentDialogHandler()
            const getItem = { id: getSharepointId }
            this.getSubFoldersItems(getItem)
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    uploadTemplateHandler () {
      if (this.$refs.documentReference.$refs.validateForm.validate()) {
        this.documentFormloading = true
        const result = this.$formatter.cloneVariable(this.propertyModel.properties)
        let moduleUrl = ''
        if (this.module === 1) moduleUrl = 'create_for_order'
        else if (this.module === 2) moduleUrl = 'create_for_customer'
        else moduleUrl = 'create_for_equipments'
        // get active route folder and upload under there
        const getAllLength = this.parentBreadCrumbItems.length
        const getFolderId = this.parentBreadCrumbItems[getAllLength - 1] ? this.parentBreadCrumbItems[getAllLength - 1].id : ''

        this.$_executeApi('post', `sharepoint/${moduleUrl}?parent_id=${this.modelObj.id}&template_id=${result.template}&folder_id=${getFolderId}`, result)
          .finally(() => {
            this.documentFormloading = false
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.uploadedSuccess') })
            this.closeDocumentDialogHandler()
            const getItem = { id: getFolderId }
            this.getSubFoldersItems(getItem)
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    getModuleTemplates () {
      this.$_executeApi('get', `documenttemplates/get_by_module/${this.module}`)
        .then(response => {
          this.templateList = []
          this.templateList = response.data
        })
    },
    saveOrUpdateFolder () {
      this.folderLoading = true
      const getAllLength = this.parentBreadCrumbItems.length
      const getSharepointId = this.parentBreadCrumbItems[getAllLength - 1] ? this.parentBreadCrumbItems[getAllLength - 1].id : this.modelObj.sharepoint_id
      const model = { name: this.folderObj.folder_name, parent_id: getSharepointId }
      const url = this.isCreateFolder ? 'sharepoint/create_folder' : 'sharepoint/rename'
      const method = this.isCreateFolder ? 'post' : 'put'
      if (!this.isCreateFolder) model.id = this.folderObj.id
      if (this.isCreateFolder && this.modelObj) {
        model.recordid = this.modelObj.id
        model.module = +this.module
      }
      this.$_executeApi(method, url, model)
        .finally(() => {
          this.folderLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
          const getItem = { id: getSharepointId }
          if (this.folderObj.childRef) { // to save and react with child folders
            const { item, obj, index } = this.folderObj.childRef
            // to should navigate to it's parent
            const getObj = this.$formatter.cloneVariable(obj)
            if (getObj) {
              const getChildLength = getObj.breadcrumps.length
              const getParentId = getObj.breadcrumps[getChildLength - 1] ? getObj.breadcrumps[getChildLength - 1].id : 0
              this.navigateToChildItem(item, obj, index, getParentId)
            }
          } else this.getSubFoldersItems(getItem)
          this.closeFolderDialogHandler()
        })
    },
    navigateToChildItem (item, obj, index, parentId) {
      this.documentLoading = true
      const getId = parentId || item.id
      this.$_executeApi('get', `sharepoint/get_subfolder_items/${getId}`)
        .then((response) => {
          const list = response.data
          list.forEach(element => {
            if (!element.is_document) element.mimetype = 'folder'
          })
          const getObj = this.$formatter.cloneVariable(obj)
          getObj.items = list
          const breadcrumbItem = { id: getId, text: item.name, path: item.path }
          const getIndex = getObj.breadcrumps.findIndex(x => x.id === getId)
          if (getIndex >= 0) {
            const getAll = getIndex + 1
            const getTotalCount = getObj.breadcrumps.length
            getObj.breadcrumps.splice(getAll, getTotalCount - getAll)
          } else {
            getObj.breadcrumps.push(breadcrumbItem)
          }
          this.$set(this.listOfRelatedDocuments, index, getObj)
        })
        .finally(() => {
          this.documentLoading = false
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
<style>
.areaBg {
  background-color: lightgray;
}
</style>
